module.exports = __webpack_public_path__ + "img/logo-6.e805503b.svg";